
/*
  电话号码 ****
*/
let telephone = value => {
  let val = value.slice(0, 3) + '****' + value.slice(-4)
  return val
}
let getdatetoday = value => {
  if (value) {
    let arr = value.split(' ')
    return arr[0]
  } else {
    return '未知'
  }
}
// 强制保留2位小数，如：2，会在2后面补上00.即2.00
let toDecimal2 = x => {
  let y = parseFloat(x)
  if (isNaN(y)) {
    return false
  }
  let f = Math.round(x * 100) / 100
  let s = f.toString()
  let rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

/* 将100000转为100,000.00形式 */
var dealNumber = function (money) {
  if (money && money != null) {
    money = String(money)
    var left = money.split('.')[0]
    var right = money.split('.')[1]
    var temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g)
    if (right) {
      return (
        (Number(money) < 0 ? '-' : '') +
            temp
              .join(',')
              .split('')
              .reverse()
              .join('') + '.' + right
      )
    } else {
      return (
        (Number(money) < 0 ? '-' : '') +
            temp
              .join(',')
              .split('')
              .reverse()
              .join('')
      )
    }
  } else if (money === 0) {
    // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00'
  } else {
    return '0.00'
  }
}

let dateFormat = val => new Date(val).format() // yyyy-MM-dd HH:mm:ss格式
let dateFormatDay = val => new Date(val).format('yyyy-MM-dd') // yyyy-MM-dd格式

export {
  telephone,
  getdatetoday,
  toDecimal2,
  dealNumber,
  dateFormat,
  dateFormatDay
}
